<template>
  <div>
    <span v-if="data.column.field === 'createdAt'">
      <div class="d-flex justify-content-between">
        <span>
          {{ data.row.createdAt }}
        </span>
        <span class="d-flex">
          <b-button
            v-b-modal.modal-add-user
            variant="link"
            class="p-0"
            @click="setUserModel(data.row)"
          >
            <GjIcon
              name="Edit"
              class="text-primary"
            />
          </b-button>
          <b-button
            v-b-modal.modal-small-delete
            variant="link"
            class="p-0"
            @click="deleteUser(data.row)"
          >
            <GjIcon
              name="Delete"
              class="text-danger"
            />
          </b-button>
        </span>

      </div>
    </span>

    <!-- Column: Common -->
    <span v-else>
      {{ data.formattedRow[data.column.field] }}
    </span>
  </div>
</template>

<script>
import GjIcon from '@gjirafatech/gjirafa-icons/Icon.vue'
import store from '@/store'

export default {

  components: {
    GjIcon,
  },
  props: {
    // eslint-disable-next-line vue/require-default-prop
    data: {
      type: [Array, Object],
    },
  },
  setup() {
    const deleteUser = row => store.commit('SET_ROW_TO_DELETE', row)
    const setUserModel = userModel => {
      const model = { ...userModel }
      store.commit('SET_USER_MODEL', model)
    }
    return {
      deleteUser, setUserModel,
    }
  },
}
</script>
